<template>
    <div class="planSelector">
        <table class="planGrid">
            <tr>
                <td class="plFeatureName plTransCell">{{localize('selec_order_option')}}</td>
                <td>{{localize('pro').toUpperCase()}}</td>
                <td>{{localize('full_service')}}</td>
            </tr>
            <tr>
                <td class="plFeatureName">{{localize('implant_positioning_mcenter')}}</td>
                <td></td>
                <td><i class="fal fa-check"></i></td>
            </tr>
            <tr>
                <td class="plFeatureName">{{localize('surgical_plan_review')}}</td>
                <td></td>
                <td><i class="fal fa-check"></i></td>
            </tr>
            <tr>
                <td class="plFeatureName">{{localize('template_design_by_mcenter')}}</td>
                <td><i class="fal fa-check"></i></td>
                <td><i class="fal fa-check"></i></td>
            </tr>
            <tr>
            <td class="plFeatureName">{{localize('template_manufacturing_by_mcenter')}}</td>
                <td><i class="fal fa-check"></i></td>
                <td><i class="fal fa-check"></i></td>
                </tr>
            <tr>
                <td></td>
                <td><a class="btn btn-primary-outline rounded btnSelectPlan">{{localize('select')}}</a></td>
                <td><a class="btn btn-primary-outline rounded btnSelectPlan">{{localize('select')}}</a></td>
            </tr>
        </table>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "order-plan",
  data() {
    return {
      contacts: []
    };
  },
  mounted() {
    let vm = this;
  },
  computed: {
    ...mapGetters(["userID", "userToken"])
  }
};
</script>



<style scoped>
  .planSelector
  {
    clear: both;width: 100%;min-height: 300px;    
  }
  .planGrid
  {
    margin: auto;display: table;width: 600px;
  }
  .planGrid tr td
  {
    padding: 10px 20px;font-size: 12px;vertical-align: middle;
  }
  .planGrid tr td i
  {
    color:#1178be;
  }


  
  .planGrid tr:nth-child(1) td
  {
    font-size: 16px;padding: 20px 20px;
  }
  .planGrid tr td:nth-child(2),
  .planGrid tr td:nth-child(3)
  {
    text-align: center;
  }

  .planGrid tr .plTransCell
  {
    background-color: transparent;
  }

  .planGrid tr td:nth-child(1)
  {
    width: 50%;
  }
  .planGrid tr td:nth-child(2)
  {
    width: 25%;background-color: #f5f5f5;
  }
  .planGrid tr td:nth-child(3)
  {
    width: 25%;background-color: #f5f5f5;
  }




  .planCol
  {
    display: inline;display: table-cell;margin: 1px; border: solid 1px #fff; 
  }
  .planCol:nth-child(1)
  {
    width: 50%;
  }
  .planCol:nth-child(2)
  {
    background-color: #1178be;
    width: 25%;
  }
  .planCol:nth-child(3)
  {
    width: 25%;
    background-color: #1178be;
  }
  .planCol .pc
  {
    vertical-align: middle;
    padding: 15px 15px;
    border: solid 1px #fff;
    font-size: 12px;
  }
  .planCol .pc:nth-child(1)
  {
    font-size: 20px;
  }
  .plFeatureName
  {
    background-color: #f3faff;        
  }
  .btnSelectPlan
  {
    font-size: 14px;
    padding: 5px 20px !important;
    background-color: transparent;
  }

  .planCol .pc.featureTop
  {
    background-color: #f3faff;  
    text-align: center;  
  }
  .planCol .pc.featureVal
  {
    background-color: #f3faff;  
    text-align: center;  
    line-height: 14px;
    font-size: 14px;
  }

  
</style>